// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1S1Up","range":"MonthRangeSwitch_range__3luCK","disabled":"MonthRangeSwitch_disabled__3na6N"};